// constants.ts
import dayjs from 'dayjs';

export enum ComplexPromotionCondition {
  AND = 'AND',
  ALL = 'ALL',
}

export enum RewardType {
  DISCOUNT = 'DISCOUNT',
  POINTS = 'POINTS',
  PERCENTAGE = 'PERCENTAGE',
}

export enum ComplexPromotionRewardTypeValues {
  DISCOUNT = 0,
  PERCENTAGE = 1,
}

export enum ComplexPromotionType {
  MULTI_BUY = 'MULTI_BUY',
  MIX_MATCH = 'MIX_MATCH',
  SELLER_PROMO = 'SELLER_PROMO',
  BOGO = 'BOGO',
  COMBO_SET = 'COMBO_SET',
}

export const NUMBER_OF_PRODUCTS_TO_SHOW = 20;

export const PROPOINT_COLLECTION = 'PROPOINT_PROMOTION';
export const DEFAULT = 'DEFAULT';

export const TRANSLATION_KEYS = {
  PROPOINT: {
    TAG: 'loyalty.proPointPromotions.complexPromotion.proPoint',
    DESCRIPTION: 'loyalty.proPointPromotions.complexPromotion.subHeader',
  },
  [ComplexPromotionType.MULTI_BUY]: {
    TAG: 'loyalty.proPointPromotions.complexPromotion.multiBuy',
    DESCRIPTION: 'loyalty.proPointPromotions.complexPromotion.multiBuyHeader',
  },
  [ComplexPromotionType.MIX_MATCH]: {
    TAG: 'loyalty.proPointPromotions.complexPromotion.comboSet',
    DESCRIPTION: '',
  },
  [ComplexPromotionType.SELLER_PROMO]: {
    TAG: 'loyalty.proPointPromotions.complexPromotion.comboSet',
    DESCRIPTION: '',
  },
};

// Loyalty and Campaign s3 file names
export const LOYALTY_AND_CAMPAIGN_CDN_FILE_NAMES = {
  confetti3dIcon: 'confetti3dIcon.png',
  congratulationsWelcomeCampaign: 'congratulationsWelcomeCampaign.png',
  withHoldingTaxDownloadIcon: 'documentScanner.png',
  ellipseBackground: 'ellipseBackground.png',
  emptyVoucherIcon: 'loyaltyVoucherEmpty.png',
  giftWrapRed: 'loyaltyRewardGiftRedBox.png',
  jadhaiPlusLogo: 'jadhaiPlusLogo.png',
  loyaltyDashboardHeaderCoin: 'loyaltyDashboardHeaderCoin.png',
  loyaltyIntro: 'loyaltyIntro.png',
  loyaltyLedgerNoPoints: 'loyaltyLedgerNoPoints.png',
  loyaltyPointsTag: 'loyaltyPointsTag.png',
  loyaltyRewardVouchersPair: 'loyaltyRewardVouchersPair.png',
  newPoint: 'newPoint.png',
  noCampaignSpendingHistory: 'noCampaignSpendingHistory.png',
  noProPointsPromotionsIcon: 'noProPointsPromotionsIcon.png',
  productAdjustWarning: 'productAdjustWarningIcon.png',
  productUnavailable: 'productUnavailable.png',
  rewardCenterHeader: 'rewardCenter.png',
  voucherRedeemSuccess: 'voucherRedeemSuccess.png',
  zoomIcon: 'zoomIcon.png',

  // INFO: below tier icon file names are not using camel case as they are used in the backend and should not be changed
  // As silver tier and platinum tier svgs are larger size, we are using strapi CDN to fetch them rest already in the codebase
  silverTier: 'Silver-Tier.png',
  platinumTier: 'Platinum-Tier.png',

  voucherSuccessIcon: 'voucherSuccessIcon.png',
  voucherIconNew: 'voucherIconNew.png',
  bogoIcon: 'bogoIcon.png',
  comboSetIcon: 'comboSetIcon.png',
  multibuyIcon: 'multibuyIcon.png',
  proPointIcon: 'proPointIcon.png',
  voucherIcon: 'voucherIcon.png',
};

export enum PROMOTION_REWARD {
  BATH_OFF = 'Get $ off',
  PERCENTAGE_OFF = 'Get % off',
  BATH_OFF_3P = 'AMOUNT_OFF',
  PERCENTAGE_OFF_3P = 'PERCENTAGE_OFF',
}
export const getRm3PromotionRewardType = (type: string) => {
  // string contain check
  if (type.includes(PROMOTION_REWARD.BATH_OFF)) {
    return PROMOTION_REWARD.BATH_OFF;
  }
  if (type.includes(PROMOTION_REWARD.PERCENTAGE_OFF)) {
    return PROMOTION_REWARD.PERCENTAGE_OFF;
  }
  return type;
};

export const ComplexPromotionIconMap: Record<string, string> = {
  [ComplexPromotionType.COMBO_SET]: LOYALTY_AND_CAMPAIGN_CDN_FILE_NAMES.comboSetIcon,
  [ComplexPromotionType.MIX_MATCH]: LOYALTY_AND_CAMPAIGN_CDN_FILE_NAMES.comboSetIcon,
  [ComplexPromotionType.MULTI_BUY]: LOYALTY_AND_CAMPAIGN_CDN_FILE_NAMES.multibuyIcon,
  [ComplexPromotionType.BOGO]: LOYALTY_AND_CAMPAIGN_CDN_FILE_NAMES.bogoIcon,
};

export const buildStrapiCDNURL = (imageFileName: string): string => {
  const assetUrl = 'https://strapi-cdn.mango-qa.siammakro.cloud/uploads/';
  const postfix = `?version=${dayjs().format('YYYYMMDDA')}`;

  return assetUrl + imageFileName + postfix;
};

export const PROMOTION_COLORS = {
  PROPOINT: {
    BACKGROUND: '#FFF7D4',
    TEXT: '#835111',
  },
  DEFAULT: {
    BACKGROUND: '#EADEFF',
    TEXT: '#6109FF',
  },
};

export const determinePromotionType = (
  isBOGOEnabled: boolean,
  productDisplayPrice: number | undefined,
  discount: number,
  promotionTargetValue: number,
  promotionSubType: string,
): string => {
  //The rule for BOGO is to buy 2x of the same product, and the discount is equal to the item’s selling price.
  const isBOGO =
    isBOGOEnabled &&
    productDisplayPrice === discount &&
    promotionTargetValue === 2 &&
    promotionSubType === ComplexPromotionType.MULTI_BUY;

  return isBOGO ? ComplexPromotionType.BOGO : promotionSubType;
};
